"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogoScene = void 0;
const Scene_1 = require("./Scene");
const pixi_js_1 = require("pixi.js");
const DrawingBackground_1 = require("../blocks/DrawingBackground");
const Global_1 = require("../Global");
const blocks_1 = require("../blocks");
const logo_svg_1 = __importDefault(require("../../assets/svg/logo.svg"));
const WigglyText_1 = require("../objects/WigglyText");
const settings_1 = require("../config/settings");
class LogoScene extends Scene_1.Scene {
    constructor(app, sceneManager, gameManager) {
        super(app, sceneManager, gameManager);
        this.foreground = this.makeForeground();
        this.belowground = this.makeBelowGround();
        this.makeLogo().then(logo => {
            this.logo = logo;
            this.layout();
        });
        this.layout();
    }
    makeLogo() {
        return __awaiter(this, void 0, void 0, function* () {
            const source = yield pixi_js_1.Texture.fromURL(logo_svg_1.default);
            const sprite = pixi_js_1.Sprite.from(source);
            sprite.anchor.set(0.5);
            sprite.scale.set((0, Global_1.px)(0.1));
            return this.addChild(sprite);
        });
    }
    makeBelowGround() {
        const style = blocks_1.Block.textStyle(settings_1.Settings.titleSize);
        style.fill = settings_1.Settings.blackColor;
        style.wordWrap = true;
        style.align = 'center';
        const text = new WigglyText_1.WigglyText(this.app, 'Race against opponents in this fast-paced drawing game!', style);
        text.anchor.set(0.5);
        text.visible = false;
        return this.addChild(text);
    }
    makeForeground() {
        const text = new WigglyText_1.WigglyText(this.app, settings_1.Settings.title, blocks_1.Block.textStyle(settings_1.Settings.titleSize * 2));
        text.anchor.set(0.5);
        text.visible = false;
        return this.addChild(text);
    }
    makeBackground() {
        const container = new DrawingBackground_1.DrawingBackground(this.app, 15);
        container.alpha = 0.5;
        return (this.addChild(container));
    }
    layout() {
        super.layout();
        if (this.logo) {
            this.background.start();
            this.logo.position.set(this.center.x, this.center.y);
            this.foreground.position.set(this.logo.x, this.logo.y - this.logo.height / 2 - (0, Global_1.px)(30));
            this.belowground.position.set(this.logo.x, this.logo.y + this.logo.height / 2 + (0, Global_1.px)(30));
            this.belowground.style.wordWrapWidth = this.app.screen.width;
            this.logo.visible = this.foreground.visible = this.belowground.visible = true;
        }
    }
}
exports.LogoScene = LogoScene;
